module.exports = __webpack_public_path__ + "5a879a3112ef99fbf61d874246f8e9fc.svg";